import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { MaintenanceModalService } from '../service/components/maintenance-modal.service';
import { AuthService } from '../service/auth/auth.service';

export const ErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const maintenanceModalService = inject(MaintenanceModalService);
  const authService = inject(AuthService);

  return next(req).pipe(
    catchError((error) => {
      console.error('Error interceptado:', error);

      // Verificar diferentes tipos de errores de conexión
      const isServerError = error.status === 500;
      const isCorsError = error.message?.includes('CORS');
      const isConnectionError =
        error.message?.includes('ERR_CONNECTION_CLOSED') ||
        error.message?.includes('ERR_CONNECTION_REFUSED') ||
        error.message?.includes('ERR_NETWORK') ||
        error.message?.includes('Net::') ||
        error.message?.includes('Failed to fetch') ||
        error.status === 0; // Status 0 indica que no hubo respuesta del servidor

      if (error.status === 401 && error.error.message === 'Token Expirado') {
        authService.logout();
      }

      if (isServerError || isCorsError || isConnectionError) {
        maintenanceModalService.showMaintenanceModal();
      }

      return throwError(() => error);
    })
  );
};
